import axios from "axios";
import { ApiBaseURL, LocalApiBaseURL } from "config/config";

export const API_URL = window.location.hostname === "localhost" ? LocalApiBaseURL : ApiBaseURL;

export const axiosApi = axios.create({
    baseURL: API_URL,
});
axiosApi.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("token");
        if (token) {
            config.headers["Authorization"] = token; // Add the token to the request headers
        }
        return config;
    },
    (error) => {
        // Handle request error
        return Promise.reject(error);
    }
);

// Add Axios response interceptor to handle specific error codes
axiosApi.interceptors.response.use(
    (response) => {
        // If the response is successful, simply return the response
        return response;
    },
    (error) => {
        if (error.response && error.response.status === 401) {
            // Redirect to the login page if the error code is 401

            localStorage.clear();
            window.location.href = "/login";
        }
        // Reject the promise for other errors
        return Promise.reject(error);
    }
);


export async function retrievePolicyContent(url, config = {}) {
    return await axios
        .get(QTOK_API_URL + url, { ...config })
        .then((response) => response.data);
}

export async function retrieveDataPost(url, data, config = {}) {
    let res = await axios
        .post(url, { ...data }, { ...config })
        .then((response) => response.data);
    return res;
}

export async function get(url, config = {}) {
    return await axiosApi
        .get(url, { ...config })
        .then((response) => response.data);
}

export async function post(url, data, config = {}) {
    return axiosApi
        .post(url, { ...data }, { ...config })
        .then((response) => response.data);
}

export async function postAsForm(url, data, config = {}) {
    return axiosApi
        .post(url, data, { ...config })
        .then((response) => response.data);
}
export async function putAsForm(url, data, config = {}) {
    return axiosApi
        .put(url, data, { ...config })
        .then((response) => response.data);
}

export async function put(url, data, config = {}) {
    return axiosApi
        .put(url, { ...data }, { ...config })
        .then((response) => response.data);
}

export async function del(url, id, config = {}) {
    return await axiosApi
        .delete(
            url,
            {
                params: { id },
            },
        )
        .then((response) => response.data);
}

export const apiHeader = () => {
    let obj = localStorage.getItem('token');
    if (obj) {
        axiosApi.defaults.headers.common["Authorization"] = obj;
    } else {
        return {};
    }
};
